import React from "react";

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="17"
      fill="none"
      viewBox="0 0 16 17"
    >
      <path
        fill="#0C2340"
        d="M5.932 11.515l2.072-1.258 2.072 1.258-.549-2.356 1.842-1.593-2.426-.195-.939-2.231-.938 2.23-2.426.196L6.48 9.159l-.549 2.356zm2.072 4.993l-2.373-2.337H2.337v-3.294L0 8.504l2.337-2.373V2.837h3.294L8.004.5l2.373 2.337h3.294v3.294l2.337 2.373-2.337 2.373v3.294h-3.294l-2.373 2.337zm0-1.983l1.771-1.77h2.48v-2.48l1.77-1.77-1.77-1.772V4.254h-2.48l-1.77-1.77-1.772 1.77H3.754v2.48l-1.77 1.77 1.77 1.771v2.48h2.48l1.77 1.77z"
      ></path>
    </svg>
  );
}

export default Icon;